import { createSelector } from 'reselect';
import getOrdering from './getOrdering';

export default createSelector(
  [getOrdering],
  (ordering): TransactionHistory[] | null => {
    return ordering.transactionHistory;
  },
);
